import { Suspense } from 'react';

// project import
import Loader from './Loader';

const Loadable = (Component) =>
  function LoadableComponent(props) {
    return (
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    );
  };

export default Loadable;
